<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8YmM40/tc-custom/9780830869060.jpg?1696025395231" alt="This image is the cover for the book Uncommon Decency"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Uncommon Decency
      </h1>
      <p class="bookDescription body article font2">
        <p>Can Christians act like Christians even when they disagree? In these wild and diverse times, right and left battle over the airwaves, prolifers square off against prochoicers, gay liberationists confront champions of the traditional family, artists and legislators tangle, even Christians fight other Christians whose doctrines aren't "just so." Richard Mouw has been actively forging a model of Christian civil conversation with those we might disagree with—atheists, Muslims, gay activists and more. He is concerned that, too often, Christians have contributed more to the problem than to the solution. But he recognizes—from his dialogues with those from many perspectives—that it's not easy to hold to Christian convictions and treat sometimes vindictive opponents with civility and decency. Few if any people in the evangelical world have conversed as widely and sensitively as Mouw. So few can write more wisely or helpfully than Mouw does here about what Christians can appreciate about pluralism, the theological basis for civility, and how we can communicate with people who disagree with us on the issues that matter most.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Richard J. Mouw
      </h2>
      
      <p class="authorDescription body article"><p>Richard J. Mouw (PhD, University of Chicago) now serves as professor of faith and public life after twenty years as president of Fuller Theological Seminary. He has written over twenty books on topics of social ethics, philosophy of culture and interfaith dialogue, including <em>Uncommon Decency, The Challenges of Cultural Discipleship, Praying at Burger King, The God Who Commands, Calvinism in the Las Vegas Airport, The Smell of Sawdust</em> and <em>Talking with Mormons: An Invitation to Evangelicals.</em> A leader in interfaith theological conversations, particularly with Mormons and Jewish groups, Mouw served for six years as co-chair of the official Reformed-Catholic Dialogue and as president of the Association of Theological Schools. For seventeen years he was a professor of philosophy at Calvin College and in 2007, Princeton Theological Seminary awarded him the Abraham Kuyper Prize for Excellence in Reformed Theology and Public Life.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?c8e4b310